import { ErrorType } from "./types";

export default class NetworkError extends Error {
  public status;
  public type;
  public timestamp;

  /**
   * Constructs a Network Error.
   *
   * @param message The error message.
   * @param status The network call response status.
   */
  constructor(message: string, status?: number) {
    super(message);
    this.status = status;
    this.timestamp = new Date();
    this.type = ErrorType.NETWORK;
    if (
      "captureStackTrace" in Error &&
      typeof Error.captureStackTrace === "function"
    ) {
      Error.captureStackTrace(this, NetworkError);
    } else if (Object.prototype.hasOwnProperty.call(Error, "stack")) {
      this.stack = new Error().stack;
    }
  }
}
